import { defineRecipe } from '@chakra-ui/react';

import { textFieldHeights, textFieldInputPaddingX } from './text-field.kds';

const textFieldSizeStyles = (size: keyof typeof textFieldHeights) => ({
  '--input-height': textFieldHeights[size],
  minH: textFieldHeights[size],
  h: textFieldHeights[size],
  px: textFieldInputPaddingX,
});

/** KDS Text Field input recipe — Figma node 49:146. Registered as Chakra `input` in `theme/system.ts`. */
export const inputRecipe = defineRecipe({
  base: {
    textStyle: 'default.regular',
    borderRadius: 'md',
    color: 'neutral.500',
    width: 'full',
    _placeholder: {
      color: 'neutral.250',
    },
  },
  variants: {
    variant: {
      outline: {
        bg: 'neutral.0',
        borderWidth: '1px',
        borderColor: 'neutral.250',
        _hover: {
          borderColor: 'neutral.350',
        },
        _focus: {
          borderColor: 'brand.500',
          outline: 'none',
        },
        _invalid: {
          borderColor: 'red.700',
          _hover: {
            borderColor: 'red.700',
          },
          _focus: {
            borderColor: 'red.700',
          },
        },
        _disabled: {
          bg: 'neutral.50',
          borderColor: 'neutral.200',
          color: 'neutral.350',
          opacity: 1,
          cursor: 'not-allowed',
          _placeholder: {
            color: 'neutral.350',
          },
        },
      },
    },
    size: {
      sm: textFieldSizeStyles('sm'),
      md: textFieldSizeStyles('md'),
      lg: textFieldSizeStyles('lg'),
    },
  },
  defaultVariants: {
    variant: 'outline',
    size: 'sm',
  },
});
